import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function parentTaxAuthorityReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state
        .set('loading', false)
        .set('data', mapParentTaxAuthorities(state.get('data'), action.payload));
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    default:
      return state;
  }
}

function mapParentTaxAuthorities(data, payload) {
  const parentTaxAuthorities = Map({ [`${payload.taxCode}`]: payload.data });
  return data ? data.merge(parentTaxAuthorities) : parentTaxAuthorities;
}
